import React, { useState } from "react";
import { Select, Button, Modal } from "antd";
import "antd/dist/antd.css";
import { FilterFilled, FilterOutlined } from "@ant-design/icons";

const { Option } = Select;

interface PodOption {
  value: string;
  label: string;
}

interface CityOption {
  value: string;
  label: string;
}

interface MetricOption {
  value: string;
  label: string;
}

interface FilterByPodProps {
  selectedPod: string[] | undefined | null;
  selectedCity: string | undefined;
  handlePodChange: (value: string[], v: string) => void;
  handleSelectedCity: (value: string) => void;
  podOptions: PodOption[];
  cityOptions: CityOption[];
  filterType: string | undefined;
  setFilterType: (value: string) => void;
  disablePodFilter?: boolean;
  disableCityFilter?: boolean;
  disableClearFilterButton?: boolean;
}

const FilterByPod: React.FC<FilterByPodProps> = ({
  selectedPod,
  selectedCity,
  handlePodChange,
  handleSelectedCity,
  podOptions,
  cityOptions,
  filterType,
  setFilterType,
  disablePodFilter,
  disableCityFilter,
  disableClearFilterButton,
}) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [tempSelectedPod, setTempSelectedPod] = useState<string[] | undefined | null>(selectedPod);

  const handleFilterTypeChange = (value: string) => {
    setFilterType(value);
    handlePodChange([], value); // Pass the new filter type
  };

  const handleApplyFilters = () => {
    // @ts-ignore
    handlePodChange(tempSelectedPod || []); // Ensure `null` is treated as `[]`
    setIsModalVisible(false); // Hide the modal on apply
  };

  const isFilterActive = tempSelectedPod?.length || selectedCity;

  return (
    <div style={{ marginLeft: "1rem" }}>
      <div style={{ color: "black" }}>
        {isFilterActive ? (
          <FilterFilled style={{ fontSize: "2rem", color: "blue" }} onClick={() => setIsModalVisible(true)} />
        ) : (
          <FilterOutlined style={{ fontSize: "2rem" }} onClick={() => setIsModalVisible(true)} />
        )}
      </div>

      <Modal
        title="Filter Options"
        visible={isModalVisible}
        maskStyle={{
          backgroundColor: "rgba(0, 0, 0, 0.9)",
        }}
        onCancel={() => setIsModalVisible(false)}
        footer={[
          <Button
            key="clear"
            onClick={() => {
              handlePodChange([], filterType || "");
              handleSelectedCity("");
              window.location.reload();
            }}
            disabled={disableClearFilterButton}
          >
            Clear Filters
          </Button>,
          <Button key="ok" type="primary" onClick={handleApplyFilters}>
            OK
          </Button>,
        ]}
      >
        <Select
          id="cityFilter"
          value={selectedCity}
          onChange={(value) => handleSelectedCity(value)}
          placeholder="Filter by City"
          showSearch
          style={{
            width: "100%",
            marginBottom: "16px",
            borderStyle: disableCityFilter ? undefined : "solid",
            borderWidth: "0.7px",
          }}
          disabled={disableCityFilter}
        >
          {cityOptions.map((option) => (
            <Option key={option.value} value={option.value}>
              {option.label}
            </Option>
          ))}
        </Select>

        <Select
          id="podFilter"
          mode="multiple"
          value={tempSelectedPod || undefined} // Ensure `null` is treated as `undefined`
          onChange={setTempSelectedPod} // Provide a default value for filterType
          placeholder="Select a Pod"
          showSearch
          allowClear
          maxTagCount={7}
          filterOption={(input, option) => {
            const label = option?.label;
            return typeof label === "string" && label.toLowerCase().includes(input.toLowerCase());
          }}
          options={podOptions.map((option) => ({
            value: option.value,
            label: option.value + " - " + option.label,
          }))}
          style={{
            width: "100%",
            maxHeight: "100px",
            borderStyle: !selectedCity || disablePodFilter ? undefined : "solid",
            borderWidth: "0.7px",
          }}
          dropdownStyle={{ maxHeight: "200px", overflow: "hidden" }}
          disabled={!selectedCity || disableCityFilter} // Disable if no city is selected
        />
      </Modal>
    </div>
  );
};

export default FilterByPod;
